import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RoutesCons } from 'src/app/constants/const';
import { RouteShoppingCarItem, ShoppingTab, ShoppingTabCompare } from 'src/app/model/http/myActivity.model';
import { MissingProductsInSavedCart } from 'src/app/model/http/shoppingList';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { ObservableService } from 'src/app/services/observable.service';

@Component({
  selector: 'app-notification-saved-products',
  templateUrl: './notification-saved-products.component.html',
  styleUrls: ['./notification-saved-products.component.scss'],
})
export class NotificationSavedProductsComponent {
  routes = RoutesCons;
  subscriptions = new Subscription();
  tabs = RouteShoppingCarItem;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MissingProductsInSavedCart[],
    private router: Router,
    private dialog: MatDialogRef<NotificationSavedProductsComponent>,
  ) {}

  onScroll(): void {}

  redirect(route: string[]): void {
    this.dialog.close();
    this.router.navigate(route);
  }
}
